<template>
    <div id="div_odontograma" 
        class="odontograma"
    >
        <!-- preenche os quadrantes da ESQ pra DIR, de CIMA pra BAIXO -->
        <div v-for="quadrante in quadrantesArray(tipoDenticao)"  
            :key="quadrante"
            v-bind="{
                id    : 'q' + quadrante,
                style : { 
                    justifyContent   : ((quadrante % 2) == 0) ? 'start' : 'end',
                    gridTemplateRows : (tipoDenticao == gConsts.denticao.PERMANTENTE) ? 'auto auto' : 'auto auto auto auto'
                }
            }"            
            class="quadrante"
        >
            <div v-for="dente in denteNodes.filter(node => denteInQuadrante(parseInt(node.layout.label, 10), quadrante))"
                :key="dente.layout.label"
                @click.stop="handleClick(dente)"
                class="denteLabel"
                :data-selected="activeDenteNode == dente.id"
                :data-dente-ausente="!dentePresente(dente)"
                v-bind="{
                    id         : dente.id,
                    style: {
                        '--dente-color' : getDenteColor(dente),
                    },
                    class : {
                        bottom : posicaoQuadrante(quadrante) == 'bottom'
                    }
                }"
            >                
                <div
                    class="labelColor"
                    v-bind="{
                        id    : dente.id + '_color',
                        style : {
                            background : getDenteColor(dente),
                        },
                    }"
                ></div>


                <div 
                    class="labelText"
                    v-bind="{
                        id : dente.id + '_text',                 
                    }"
                >                    
                    {{ dente.layout.label }}
                </div>     
            </div>  
        </div>
    </div>

</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';


// =========================================================================================

export default {
    name : 'odontogramaCMP',
    props: {
        id       : String
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
            gConsts : gConsts,
            activeDenteNode: null
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([
        ]),

        tipoDenticao() {
            return this.GET_activeElem.labels[gConsts.denticao.LAYER];
        },

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_activeElem',
            'GET_usedLabels',
            'GET_dentesPresentes',
            'GET_nodesArray',
            'GET_activeLayer',
        ]),

        denteNodes() {
            return this.GET_nodesArray.filter(node => (node.layout.parent == 'layer_dentesSeg'));
        }
    },

    // -----------------------------------------------------------------

    watch: {
        // 'GET_activeLabel': function() {
        //     if (!(this.layer == this.GET_activeLayer)) {
        //         return;
        //     }

        //     this.$nextTick(function() {
        //         // faz o scroll pra label selecionado caso necessario
        //         document.getElementById('denteLabel[' + this.GET_activeLabel + ']').scrollIntoViewIfNeeded();
        //     });                
        // }
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
        ]),

        // -----------------------------------------------------------------

        quadrantesArray(denticao) {
            var result = [5, 6, 1, 2, 3, 4, 7, 8];

            // switch (denticao) {
            //     case gConsts.denticao.types.DECIDUA : result = [5, 6, 7, 8]            ; break;
            //     case gConsts.denticao.types.MISTA   : result = [5, 6, 1, 2, 3, 4, 7, 8]; break;
            //     default : result = [1, 2, 3, 4];
            // }

            return result;
        },

        // -----------------------------------------------------------------

        denteInQuadrante(dente, quadrante) {
            var result = false;

            switch (quadrante) {
                case 1 : result = (dente > 10) && (dente < 20); break;
                case 2 : result = (dente > 20) && (dente < 30); break;
                case 3 : result = (dente > 40) && (dente < 50); break;
                case 4 : result = (dente > 30) && (dente < 40); break;
                case 5 : result = (dente > 50) && (dente < 56); break;
                case 6 : result = (dente > 60) && (dente < 66); break;
                case 7 : result = (dente > 80) && (dente < 86); break;
                case 8 : result = (dente > 70) && (dente < 76); break;
            }

            return result;
        },

        posicaoQuadrante(quadrante) {
            return [5, 6, 1, 2].includes(quadrante) ? 'top' : 'bottom';
        },

        // -----------------------------------------------------------------
        
        handleClick(node) { 
            this.activeDenteNode = this.activeDenteNode == node.id ? null : node.id;

            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: node.id, nodeType: gConsts.node.layout.types.LABEL });
            // nodes.activateNode(node, this.GET_nodesArray); 
        },

        // -----------------------------------------------------------------

        dentePresente(node) { return (this.GET_dentesPresentes.includes(node.id)); },

        getDenteColor(node) {
            return gConsts.ui.prettyColors[node?.layout?.color?.toLowerCase()] || node?.layout?.color;
        },

        // -----------------------------------------------------------------

    },

    mounted() {
            
        evtBus.$on('evt_activateNode', (payload) => {
            if (this.denteNodes.some(node => node.id == payload.label)) {
                this.activeDenteNode = payload.label;
            } else {
                this.activeDenteNode = null;
            }
        });
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>

li {
    font-size: 0.7em;
    left: 0px;
    max-width: 95%;
    margin-top: var(--spacing-sm);
    text-align: left;
}

.odontograma {
    margin-block: var(--spacing-md);
    width: 100%;
    overflow-x: auto;
    display : grid;
    grid-template-columns : auto auto;
    grid-row-gap: var(--spacing-sm);
    grid-column-gap: var(--spacing-sm);
    position : relative;
}

.vertical {
    border-left : 2px solid var(--color-black);
    height      : 100%;
    position    : absolute;
    left        : 50%;
}

.horizontal {
    border-top : 2px solid var(--color-black);
    width      : 100%;
    position   : absolute;
    top        : 50%;
}

.quadrante {
    display   : flex;    
    flex-wrap : nowrap;
    gap: var(--spacing-xs);
}

.denteLabel {
    display: grid;
    grid-template-rows: auto var(--spacing-xs) auto;
    grid-template-columns: auto;
    grid-template-areas:
        "labelColor"        
        "space"
        "labelText ";
}

.denteLabel.bottom {
    grid-template-areas:
        "labelText"
        "space"
        "labelColor";
}

.labelColor {
    grid-area: labelColor;
    width: 100%;
    justify-self: center;
    border-radius: var(--radius-xs);
    display    : inline-block;
    height     : 7px;
}

.labelText {
    position: relative;
    grid-area: labelText;
    text-align: center;
    font-size: 11px;
    padding: var(--spacing-sm) calc(var(--spacing-xs) / 2);
    font-family: var(--font-family-primary);
    border: 1px solid var(--border-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    font-family: sans-serif;
    font-weight: 700;
    color: var(--color-secondary);
    cursor: pointer;
}

.labelText::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--radius-sm);
    background: var(--dente-color);
    z-index: 1;
    opacity: 0;
}

.labelText:hover {
    opacity: 0.8;
}

.denteGrid {
    display : grid;
    grid-template-rows : 2;
    grid-template-columns : repeat(16, 26px);
    grid-row-gap: var(--spacing);
    grid-column-gap: 2px;
    :nth-child(8) {
        border-right : 3px solid var(--color-black);
        margin : var(--spacing);
    }
    :nth-child(24) {
        border-right : 3px solid var(--color-black);
    }
}

.denteLabel[data-selected="true"] .labelText {
    color: var(--color-black);
}

.denteLabel[data-selected="true"] .labelText::before {
    opacity: 0.5;
}

.denteLabel[data-dente-ausente="true"] .labelText {
    opacity: 0.3;
}

</style>